import React from 'react';
import { Grid } from '@mui/material';
import { dropStatusDocumento } from 'utils/drops';
import Input from 'components/Input';
import InputMask from 'components/InputMask';
import VirtualDrop from 'components/VirtualDrop';
import Dropdown from 'components/Dropdown';

const Filter = ({ grid, control, drops }) => {
  const checkDisplay = (name) => {
    const column = grid?.colunas?.find((c) => c?.field === name);
    if (column?.filterable) {
      return true;
    }
    return false;
  };

  return (
    <Grid container spacing={2}>
      {checkDisplay('id') && (
        <Grid item xs={12}>
          <Input name="id" control={control} label="ID" type="number" />
        </Grid>
      )}
      {checkDisplay('status') && (
        <Grid item xs={12}>
          <Dropdown
            name="status"
            control={control}
            label="Status"
            options={dropStatusDocumento}
            multiple
          />
        </Grid>
      )}
      {checkDisplay('documento') && (
        <Grid item xs={12}>
          <Input
            name="documento"
            control={control}
            label="Nº do Documento"
            type="number"
          />
        </Grid>
      )}
      {checkDisplay('documento') && (
        <Grid item xs={6}>
          <InputMask
            name="dtemissao.i"
            control={control}
            label="Data de Emissão Inicial"
            type="date"
          />
        </Grid>
      )}
      {checkDisplay('documento') && (
        <Grid item xs={6}>
          <InputMask
            name="dtemissao.f"
            control={control}
            label="Data de Emissão Final"
            type="date"
          />
        </Grid>
      )}
      {checkDisplay('documento') && (
        <Grid item xs={12}>
          <Dropdown
            name="user"
            control={control}
            label="Emitente"
            options={drops?.Users}
            multiple
          />
        </Grid>
      )}
      {checkDisplay('documento') && (
        <Grid item xs={12}>
          <Dropdown
            name="filial"
            control={control}
            label="Filial"
            options={drops?.Filial}
            multiple
          />
        </Grid>
      )}
      {checkDisplay('documento') && (
        <Grid item xs={12}>
          <Dropdown
            name="vendedor"
            control={control}
            label="Vendedor"
            options={drops?.EntidadeTipo?.filter((f) => f?.tipo === 'VENDEDOR')}
            multiple
          />
        </Grid>
      )}
      {checkDisplay('documento') && (
        <Grid item xs={12}>
          <VirtualDrop
            name="cliente"
            control={control}
            label="Cliente"
            options={drops?.Entidade}
            multiple
          />
        </Grid>
      )}
      {checkDisplay('documento') && (
        <Grid item xs={12}>
          <Input
            name="fabricante"
            control={control}
            label="Código do Fabricante"
          />
        </Grid>
      )}
      {checkDisplay('produto') && (
        <Grid item xs={12}>
          <Input name="produto" control={control} label="Produto" />
        </Grid>
      )}
      {checkDisplay('produto') && (
        <Grid item xs={12}>
          <InputMask name="quantidade" control={control} label="Quantidade" />
        </Grid>
      )}
      {checkDisplay('produto') && (
        <Grid item xs={12}>
          <InputMask name="preco" control={control} label="Preço" />
        </Grid>
      )}
      {checkDisplay('produto') && (
        <Grid item xs={12}>
          <Dropdown
            name="unidade_medida"
            control={control}
            label="Unidade de Medida"
            options={drops?.UnidadeMedida}
            multiple
          />
        </Grid>
      )}
      {checkDisplay('produto') && (
        <Grid item xs={12}>
          <Dropdown
            name="marca"
            control={control}
            label="Marca"
            options={drops?.Marca}
            multiple
          />
        </Grid>
      )}
    </Grid>
  );
};

export default Filter;
